<section class="overflow-hidden min-vh-100 d-flex align-items-center position-relative" style="z-index: 0;">
    <!-- Background Video -->
    <video #bgVideo id="video-background" class="position-absolute z-n1 top-0 h-100 w-100 object-fit-cover" playsinline muted>
        <source src="/assets/videos/plane-takeoff.mp4" type="video/mp4">
        Your browser does not support HTML5 video.
    </video>

    <!-- Background color -->
    <div #colorBackground id="color-background" class="position-absolute z-n1 top-0 h-100 w-100 bg-dark bg-opacity-25"></div>

    <!-- Background Audio -->
    <audio id="login-audio" #loginAudio loop>
        <source src="/assets/audio/LiveATC.mp3" type="audio/mpeg">
        Your browser does not support the audio element.
    </audio>

    <div #loginCard id="loginCard" class="max-w-lg mx-3 mx-sm-auto p-6 p-xl-7 rounded-5 rounded-xl-6 position-relative shadow-lg login-card">
        <div class="position-absolute z-n1 top-0 bottom-0 start-0 end-0 rounded-5 rounded-xl-6 bg-dark bg-opacity-10 backdrop-filter backdrop-blur-lg border border-white border-opacity-50"></div>

        <div class="row h-100">
            <!-- Header Top -->
            <header class="col-12 pb-7 text-center">
                <a href="javascript:;" class="m-0 text-body-emphasis text-balance text-5xl leading-tight tracking-tight fw-semibold text-decoration-none">
                    FlyDnA
                </a>
            </header>

            <div class="col-12">
                <!-- Eyeball Heading -->
                <h1 class="m-0 pb-7 text-body-emphasis text-balance text-2xl leading-tight tracking-tight fw-semibold">
                    Login to your account
                </h1>

                <form id="ngLoginForm" class="row gy-6 gx-sm-6" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                    <div class="col-12">
                        <label for="identifier" class="form-label">
                            Email or Phone Number
                        </label>
                        <input type="text" class="form-control bg-transparent border-light border-opacity-75" name="identifier" id="identifier" formControlName="identifier">
                    </div>

                    <div class="col-12">
                        <div class="d-flex justify-content-between">
                            <label for="password" class="form-label">
                                Password
                            </label>
                            <a routerLink="/forgot-password" class="text-sm leading-6 fw-semibold text-decoration-none">Forgot?</a>
                        </div>
                        <input type="password" class="form-control bg-transparent border-light border-opacity-75" name="password" id="password" formControlName="password">
                    </div>

                    <div class="col-12">
                        <div class="pt-3">
                            <button #loginBtn id="loginBtn" type="submit" class="btn btn-lg btn-primary text-center w-100 rounded-pill" [disabled]="submitted">
                                <span class="btn-text" [class.d-none]="submitted">Login</span>
                                <div class="spinner-border text-light spinner-border-sm" [class.d-none]="!submitted" role="status" id="loadingSpinner">
                                    <span class="visually-hidden">Loading...</span>
                                </div>
                            </button>
                        </div>

                        <p class="m-0 mt-4 text-body text-xs leading-6 text-center">
                            You don't have an account?
                            <a routerLink="/register" class="text-decoration-none fw-semibold">Get Access?</a>.
                        </p>
                    </div>
                </form>
            </div>
        </div>
    </div>
</section>